import { createRequestTypes } from '../../utils';

export const SAVE_BUTTON_CLICKED = 'productInciImpurityModal/SAVE_BUTTON_CLICKED';
export const SAVE_INCI_SUBSTANCE_IMPURITIES = createRequestTypes('productInciImpurityModal/SAVE_INCI_SUBSTANCE_IMPURITIES');
